export default function ThankYou() {
  return (
    <div className="min-h-screen bg-gradient-to-br from-primary-50 to-primary-100 flex items-center justify-center p-4">
      <div className="max-w-2xl w-full text-center">
        <div className="bg-white rounded-2xl shadow-2xl p-12">
          {/* Icône SVG personnalisée */}
          <div className="mb-8">
            <svg className="w-32 h-32 mx-auto text-primary-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
            </svg>
          </div>

          {/* Message principal */}
          <h1 className="text-4xl font-bold text-gray-900 mb-4">
            Merci pour votre visite !
          </h1>
          
          <p className="text-xl text-gray-600 mb-8">
            J'espère que mon profil correspond à vos attentes.
          </p>

          {/* Informations supplémentaires */}
          <div className="space-y-4 text-gray-700">
            <p className="text-lg">
              N'hésitez pas à me contacter pour toute question ou pour planifier un entretien.
            </p>
            
            <div className="mt-8 p-6 bg-primary-50 rounded-lg">
              <p className="text-sm text-primary-800">
                ℹ️ Ce lien de visualisation expirera automatiquement après 48 heures pour des raisons de sécurité.
              </p>
            </div>
          </div>

          {/* Actions */}
          <div className="mt-8 flex flex-col sm:flex-row gap-4 justify-center">
            <button
              onClick={() => window.close()}
              className="px-6 py-3 bg-primary-600 text-white rounded-lg hover:bg-primary-700 font-medium transition-colors"
            >
              Fermer cette fenêtre
            </button>
            
            <button
              onClick={() => window.history.back()}
              className="px-6 py-3 bg-gray-200 text-gray-700 rounded-lg hover:bg-gray-300 font-medium transition-colors"
            >
              Retour au CV
            </button>
          </div>

          {/* Footer */}
          <div className="mt-12 pt-8 border-t border-gray-200">
            <p className="text-sm text-gray-500">
              CV Viewer Pro - Visualisation sécurisée de CV
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}
